<template>
  <div class="accountcenter">
    <div class="page-title">账户中心</div>
    <!-- <div class="renewal-recharge-box">
      <div class="left-red-title">
        <div class="left-inner">
          <div class="border-left"></div>
          <div class="title-text">会员充值</div>
        </div>
      </div>
      <div class="renewal-recharge-inner">
        <div class="name-price-box">
          <div class="name-box">专业版</div>
          <div class="price-box">
            <span class="price-cont">¥{{ price.toFixed(2) }}</span
            ><span>元/月</span>
          </div>
        </div>
        <el-button
          class="custom-button btn-ff3333 btn-updatenow"
          @click.stop="handleUpdateNow"
        >
          立即{{ userIsVip ? "续费" : "升级" }}
        </el-button>
      </div>
    </div> -->
    <div class="identification-box">
      <div class="left-red-title">
        <div class="left-inner">
          <div class="border-left"></div>
          <div class="title-text">前端开发认证</div>
        </div>
      </div>
      <div class="identification-inner-content">
        <div class="identification-inner" @click="handleDownloadTest(1001)">
          <div class="inner-icon"></div>
          <div class="inner-desc">下载认证题</div>
          <div class="icon-download"></div>
        </div>
        <template v-if="userInfo.id_public_user_info!=92">
          <template v-if="userInfo.user_remark_018==1802||userInfo.user_remark_018==1803||userInfo.user_remark_018==1804">
            <div class="identification-inner succeed">
              <div class="inner-icon"></div>
              <template v-if="devIdentificationList&&devIdentificationList.id_public_middle_table">
                <template v-if="devIdentificationList.mid_table_remark_016==1602">
                  <div @click="checkPic(devIdentificationList.mid_table_remark_015)" class="inner-pay-tip" v-if="devIdentificationList&&devIdentificationList.mid_table_remark_015&&devIdentificationList.mid_table_remark_015!=-1">查看付款凭证</div>
                  <div class="inner-pay-tip green" v-else>已打款</div>
                </template>
                <el-upload
                  class="upload-code"
                  v-else
                  action="no"
                  accept=".png,.jpg"
                  :auto-upload="false"
                  :multiple="false"
                  :show-file-list="false"
                  :on-change="(file, fileList) => { handleChangePay(file, 'devIdentificationList'); }"
                >
                  <div v-if="devIdentificationList.mid_table_remark_014" class="inner-pay-tip">
                    更换支付宝收款码
                    <span @click="checkPic(devIdentificationList.mid_table_remark_014)">【查看】</span>
                  </div>
                  <div v-else class="inner-pay-tip">上传支付宝收款码</div>
                </el-upload>
              </template>
              <div class="inner-desc">
                <p>已通过认证</p>
                <el-tooltip
                  placement="bottom"
                  :enterable="true"
                  popper-class="custom-tooltip"
                >
                  <div slot="content" class="remind-tooltip-inner">
                    务必扫码，加入开发社区沟通，保持信息畅通！
                  </div>
                  <div class="icon-remind-tip"></div>
                </el-tooltip>
              </div>
              <el-tooltip
                placement="bottom"
                :enterable="true"
                popper-class="code-custom-tooltip"
                effect="light"
              >
                <div slot="content" class="code-tooltip-inner">
                  <div class="code-tooltip-inner-title">社群二维码</div>
                  <div class="code-tooltip-inner-img-wrap">
                    <el-image
                      class="code-tooltip-inner-img"
                      :src="codeurl"
                      :fit="fit">
                    </el-image>
                  </div>
                </div>
                <div class="icon-download"></div>
              </el-tooltip>
            </div>
          </template>
          <template v-else>
            <template v-if="devIdentificationList&&devIdentificationList.id_public_middle_table">
              <div v-if="devIdentificationList.mid_table_remark_005==5001" class="identification-inner under_review">
                <div class="inner-icon"></div>
                <div class="inner-desc">审核中，请耐心等待</div>
                <div class="icon-download"></div>
              </div>
              <div v-else-if="devIdentificationList.mid_table_remark_005==5002" class="identification-inner succeed">
                <div class="inner-icon"></div>
                  <template v-if="devIdentificationList&&devIdentificationList.mid_table_remark_016==1602">
                    <div @click="checkPic(devIdentificationList.mid_table_remark_015)" class="inner-pay-tip" v-if="devIdentificationList&&devIdentificationList.mid_table_remark_015&&devIdentificationList.mid_table_remark_015!=-1">查看付款凭证</div>
                    <div class="inner-pay-tip green" v-else>已打款</div>
                  </template>
                  <el-upload
                    class="upload-code"
                    v-else
                    action="no"
                    accept=".png,.jpg"
                    :auto-upload="false"
                    :multiple="false"
                    :show-file-list="false"
                    :on-change="(file, fileList) => { handleChangePay(file, 'devIdentificationList'); }"
                  >
                    <div v-if="devIdentificationList&&devIdentificationList.mid_table_remark_014" class="inner-pay-tip">更换支付宝收款码</div>
                    <div v-else class="inner-pay-tip">上传支付宝收款码</div>
                  </el-upload>
                  <div class="inner-desc">
                    <p>已通过认证</p>
                    <el-tooltip
                      placement="bottom"
                      :enterable="true"
                      popper-class="custom-tooltip"
                    >
                      <div slot="content" class="remind-tooltip-inner">
                        务必扫码，加入开发社区沟通，保持信息畅通！
                      </div>
                      <div class="icon-remind-tip"></div>
                    </el-tooltip>
                  </div>
                  <el-tooltip
                    placement="bottom"
                    :enterable="true"
                    popper-class="code-custom-tooltip"
                    effect="light"
                  >
                    <div slot="content" class="code-tooltip-inner">
                      <div class="code-tooltip-inner-title">社群二维码</div>
                      <div class="code-tooltip-inner-img-wrap">
                        <el-image
                          class="code-tooltip-inner-img"
                          :src="codeurl"
                          :fit="fit">
                        </el-image>
                      </div>
                    </div>
                    <div class="icon-download"></div>
                  </el-tooltip>
              </div>
              <template v-else-if="devIdentificationList.mid_table_remark_005==5003">
                <template v-if="devIdentificationNum>=1">
                  <div class="identification-inner fail">
                    <div class="inner-icon"></div>
                    <div class="inner-tip" @click.stop="checkReason('dialogDevFailReason')">查看原因</div>
                    <div class="inner-desc">审核失败</div>
                    <div class="icon-download"></div>
                  </div>
                </template>
                <el-upload
                  v-else
                  class="identification-inner fail"
                  action="no"
                  accept=".zip"
                  :auto-upload="false"
                  :multiple="false"
                  :show-file-list="false"
                  :on-change="(file, fileList) => { handleChangeFile(file, 'devIdentificationList'); }"
                >
                  <div>
                    <div class="inner-icon"></div>
                    <div class="inner-tip" @click.stop="checkReason('dialogDevFailReason')">查看原因</div>
                    <div class="inner-desc">审核失败，请再次提交</div>
                    <div class="icon-download"></div>                           
                  </div>
                </el-upload>
              </template>
            </template>
            <el-upload
              v-else
              class="identification-inner current"
              action="no"
              accept=".zip"
              :auto-upload="false"
              :multiple="false"
              :show-file-list="false"
              :on-change="(file, fileList) => { handleChangeFile(file, 'devIdentificationList'); }"
            >
              <div class="">
                <div class="inner-icon"></div>
                <div class="inner-desc">提交认证题</div>
                <div class="icon-download"></div>
              </div>
            </el-upload>
          </template>
        </template>
        <div v-else class="identification-inner innerTip">
          <div class="inner-icon"></div>
          <div class="inner-desc">请先登录</div>
          <div class="icon-download"></div>
        </div>
      </div>
    </div>
    <!-- <div class="identification-box">
      <div class="left-red-title">
        <div class="left-inner">
          <div class="border-left"></div>
          <div class="title-text">后端开发认证</div>
        </div>
      </div>
      <div class="identification-inner-content">
        <div class="identification-inner" @click="handleDownloadTest(1003)">
          <div class="inner-icon"></div>
          <div class="inner-desc">下载认证题</div>
          <div class="icon-download"></div>
        </div>
        <template v-if="userInfo.id_public_user_info!=92">
          <template v-if="userInfo.user_remark_029==2902">
            <div class="identification-inner succeed">
              <div class="inner-icon"></div>
              <template v-if="backIdentificationList&&backIdentificationList.id_public_middle_table">
                <template v-if="backIdentificationList.mid_table_remark_016==1602">
                  <div @click="checkPic(backIdentificationList.mid_table_remark_015)" class="inner-pay-tip" v-if="backIdentificationList&&backIdentificationList.mid_table_remark_015&&backIdentificationList.mid_table_remark_015!=-1">查看付款凭证</div>
                  <div class="inner-pay-tip green" v-else>已打款</div>
                </template>
                <el-upload
                  class="upload-code"
                  v-else
                  action="no"
                  accept=".png,.jpg"
                  :auto-upload="false"
                  :multiple="false"
                  :show-file-list="false"
                  :on-change="(file, fileList) => { handleChangePay(file, 'backIdentificationList'); }"
                >
                  <div v-if="backIdentificationList.mid_table_remark_014" class="inner-pay-tip">
                    更换支付宝收款码
                    <span @click="checkPic(backIdentificationList.mid_table_remark_014)">【查看】</span>
                  </div>
                  <div v-else class="inner-pay-tip">上传支付宝收款码</div>
                </el-upload>
              </template>
              <div class="inner-desc">
                <p>已通过认证</p>
                <el-tooltip
                  placement="bottom"
                  :enterable="true"
                  popper-class="custom-tooltip"
                >
                  <div slot="content" class="remind-tooltip-inner">
                    务必扫码，加入开发社区沟通，保持信息畅通！
                  </div>
                  <div class="icon-remind-tip"></div>
                </el-tooltip>
              </div>
              <el-tooltip
                placement="bottom"
                :enterable="true"
                popper-class="code-custom-tooltip"
                effect="light"
              >
                <div slot="content" class="code-tooltip-inner">
                  <div class="code-tooltip-inner-title">后端群二维码</div>
                  <div class="code-tooltip-inner-img-wrap">
                    <el-image
                      class="code-tooltip-inner-img"
                      :src="backCodeurl"
                      :fit="fit">
                    </el-image>
                  </div>
                </div>
                <div class="icon-download"></div>
              </el-tooltip>
            </div>
          </template>
          <template v-else>
            <template v-if="backIdentificationList&&backIdentificationList.id_public_middle_table">
              <div v-if="backIdentificationList.mid_table_remark_005==5001" class="identification-inner under_review">
                <div class="inner-icon"></div>
                <div class="inner-desc">审核中，请耐心等待</div>
                <div class="icon-download"></div>
              </div>
              <div v-else-if="backIdentificationList.mid_table_remark_005==5002" class="identification-inner succeed">
                <div class="inner-icon"></div>
                  <template v-if="backIdentificationList&&backIdentificationList.mid_table_remark_016==1602">
                    <div @click="checkPic(backIdentificationList.mid_table_remark_015)" class="inner-pay-tip" v-if="backIdentificationList&&backIdentificationList.mid_table_remark_015&&backIdentificationList.mid_table_remark_015!=-1">查看付款凭证</div>
                    <div class="inner-pay-tip green" v-else>已打款</div>
                  </template>
                  <el-upload
                    class="upload-code"
                    v-else
                    action="no"
                    accept=".png,.jpg"
                    :auto-upload="false"
                    :multiple="false"
                    :show-file-list="false"
                    :on-change="(file, fileList) => { handleChangePay(file, 'backIdentificationList'); }"
                  >
                    <div v-if="backIdentificationList&&backIdentificationList.mid_table_remark_014" class="inner-pay-tip">更换支付宝收款码</div>
                    <div v-else class="inner-pay-tip">上传支付宝收款码</div>
                  </el-upload>
                  <div class="inner-desc">
                    <p>已通过认证</p>
                    <el-tooltip
                      placement="bottom"
                      :enterable="true"
                      popper-class="custom-tooltip"
                    >
                      <div slot="content" class="remind-tooltip-inner">
                        务必扫码，加入开发社区沟通，保持信息畅通！
                      </div>
                      <div class="icon-remind-tip"></div>
                    </el-tooltip>
                  </div>
                  <el-tooltip
                    placement="bottom"
                    :enterable="true"
                    popper-class="code-custom-tooltip"
                    effect="light"
                  >
                    <div slot="content" class="code-tooltip-inner">
                      <div class="code-tooltip-inner-title">测试群二维码</div>
                      <div class="code-tooltip-inner-img-wrap">
                        <el-image
                          class="code-tooltip-inner-img"
                          :src="backCodeurl"
                          :fit="fit">
                        </el-image>
                      </div>
                    </div>
                    <div class="icon-download"></div>
                  </el-tooltip>
              </div>
              <template v-else-if="backIdentificationList.mid_table_remark_005==5003">
                <template v-if="backIdentificationNum>2&&backIdentificationList.time_4_begin&&(new Date(backIdentificationList.time_4_begin.replace(/-/g, '/')).getTime()+(7*24*60*60*1000))>Date.parse(new Date())">
                  <div class="identification-inner fail">
                    <div class="inner-icon"></div>
                    <div class="inner-tip" @click.stop="checkReason('dialogBackFailReason')">查看原因</div>
                    <div class="inner-desc">审核失败，{{ getDays(backIdentificationList.time_4_begin) }}后可再次提交</div>
                    <div class="icon-download"></div>
                  </div>
                </template>
                <el-upload
                  v-else
                  class="identification-inner fail"
                  action="no"
                  accept=".zip"
                  :auto-upload="false"
                  :multiple="false"
                  :show-file-list="false"
                  :on-change="(file, fileList) => { handleChangeFile(file, 'backIdentificationList'); }"
                >
                  <div>
                    <div class="inner-icon"></div>
                    <div class="inner-tip" @click.stop="checkReason('dialogBackFailReason')">查看原因</div>
                    <div class="inner-desc">审核失败，请再次提交</div>
                    <div class="icon-download"></div>                           
                  </div>
                </el-upload>
              </template>
            </template>
            <el-upload
              v-else
              class="identification-inner current"
              action="no"
              accept=".zip"
              :auto-upload="false"
              :multiple="false"
              :show-file-list="false"
              :on-change="(file, fileList) => { handleChangeFile(file, 'backIdentificationList');}"
            >
              <div class="">
                <div class="inner-icon"></div>
                <div class="inner-desc">提交认证截图</div>
                <div class="icon-download"></div>
              </div>
            </el-upload>
          </template>
        </template>
        <div v-else class="identification-inner innerTip">
          <div class="inner-icon"></div>
          <div class="inner-desc">请先登录</div>
          <div class="icon-download"></div>
        </div>
      </div>
    </div>  -->
    <div class="identification-box">
      <div class="left-red-title">
        <div class="left-inner">
          <div class="border-left"></div>
          <div class="title-text">测试认证</div>
        </div>
      </div>
      <div class="identification-inner-content">
        <div class="identification-inner" @click="handleDownloadTest(1002)">
          <div class="inner-icon"></div>
          <div class="inner-desc">下载认证题</div>
          <div class="icon-download"></div>
        </div>
        <template v-if="userInfo.id_public_user_info!=92">
          <template v-if="userInfo.user_remark_028==2802">
            <div class="identification-inner succeed">
              <div class="inner-icon"></div>
              <template v-if="testIdentificationList&&testIdentificationList.id_public_middle_table">
                <template v-if="testIdentificationList.mid_table_remark_016==1602">
                  <div @click="checkPic(testIdentificationList.mid_table_remark_015)" class="inner-pay-tip" v-if="testIdentificationList&&testIdentificationList.mid_table_remark_015&&testIdentificationList.mid_table_remark_015!=-1">查看付款凭证</div>
                  <div class="inner-pay-tip green" v-else>已打款</div>
                </template>
                <el-upload
                  class="upload-code"
                  v-else
                  action="no"
                  accept=".png,.jpg"
                  :auto-upload="false"
                  :multiple="false"
                  :show-file-list="false"
                  :on-change="(file, fileList) => { handleChangePay(file, 'testIdentificationList'); }"
                >
                  <div v-if="testIdentificationList.mid_table_remark_014" class="inner-pay-tip">
                    更换支付宝收款码
                    <span @click="checkPic(testIdentificationList.mid_table_remark_014)">【查看】</span>
                  </div>
                  <div v-else class="inner-pay-tip">上传支付宝收款码</div>
                </el-upload>
              </template>
              <div class="inner-desc">
                <p>已通过认证</p>
                <el-tooltip
                  placement="bottom"
                  :enterable="true"
                  popper-class="custom-tooltip"
                >
                  <div slot="content" class="remind-tooltip-inner">
                    务必扫码，加入开发社区沟通，保持信息畅通！
                  </div>
                  <div class="icon-remind-tip"></div>
                </el-tooltip>
              </div>
              <el-tooltip
                placement="bottom"
                :enterable="true"
                popper-class="code-custom-tooltip"
                effect="light"
              >
                <div slot="content" class="code-tooltip-inner">
                  <div class="code-tooltip-inner-title">测试群二维码</div>
                  <div class="code-tooltip-inner-img-wrap">
                    <el-image
                      class="code-tooltip-inner-img"
                      :src="testCodeurl"
                      :fit="fit">
                    </el-image>
                  </div>
                </div>
                <div class="icon-download"></div>
              </el-tooltip>
            </div>
          </template>
          <template v-else>
            <template v-if="testIdentificationList&&testIdentificationList.id_public_middle_table">
              <div v-if="testIdentificationList.mid_table_remark_005==5001" class="identification-inner under_review">
                <div class="inner-icon"></div>
                <div class="inner-desc">审核中，请耐心等待</div>
                <div class="icon-download"></div>
              </div>
              <div v-else-if="testIdentificationList.mid_table_remark_005==5002" class="identification-inner succeed">
                <div class="inner-icon"></div>
                  <template v-if="testIdentificationList&&testIdentificationList.mid_table_remark_016==1602">
                    <div @click="checkPic(testIdentificationList.mid_table_remark_015)" class="inner-pay-tip" v-if="testIdentificationList&&testIdentificationList.mid_table_remark_015&&testIdentificationList.mid_table_remark_015!=-1">查看付款凭证</div>
                    <div class="inner-pay-tip green" v-else>已打款</div>
                  </template>
                  <el-upload
                    class="upload-code"
                    v-else
                    action="no"
                    accept=".png,.jpg"
                    :auto-upload="false"
                    :multiple="false"
                    :show-file-list="false"
                    :on-change="(file, fileList) => { handleChangePay(file, 'testIdentificationList'); }"
                  >
                    <div v-if="testIdentificationList&&testIdentificationList.mid_table_remark_014" class="inner-pay-tip">更换支付宝收款码</div>
                    <div v-else class="inner-pay-tip">上传支付宝收款码</div>
                  </el-upload>
                  <div class="inner-desc">
                    <p>已通过认证</p>
                    <el-tooltip
                      placement="bottom"
                      :enterable="true"
                      popper-class="custom-tooltip"
                    >
                      <div slot="content" class="remind-tooltip-inner">
                        务必扫码，加入开发社区沟通，保持信息畅通！
                      </div>
                      <div class="icon-remind-tip"></div>
                    </el-tooltip>
                  </div>
                  <el-tooltip
                    placement="bottom"
                    :enterable="true"
                    popper-class="code-custom-tooltip"
                    effect="light"
                  >
                    <div slot="content" class="code-tooltip-inner">
                      <div class="code-tooltip-inner-title">测试群二维码</div>
                      <div class="code-tooltip-inner-img-wrap">
                        <el-image
                          class="code-tooltip-inner-img"
                          :src="testCodeurl"
                          :fit="fit">
                        </el-image>
                      </div>
                    </div>
                    <div class="icon-download"></div>
                  </el-tooltip>
              </div>
              <template v-else-if="testIdentificationList.mid_table_remark_005==5003">
                <template v-if="testIdentificationNum>2&&testIdentificationList.time_4_begin&&(new Date(testIdentificationList.time_4_begin.replace(/-/g, '/')).getTime()+(7*24*60*60*1000))>Date.parse(new Date())">
                  <div class="identification-inner fail">
                    <div class="inner-icon"></div>
                    <div class="inner-tip" @click.stop="checkReason('dialogTestFailReason')">查看原因</div>
                    <div class="inner-desc">审核失败，{{ getDays(testIdentificationList.time_4_begin) }}后可再次提交</div>
                    <div class="icon-download"></div>
                  </div>
                </template>
                <el-upload
                  v-else
                  class="identification-inner fail"
                  action="no"
                  accept=".png,.jpg"
                  :auto-upload="false"
                  :multiple="false"
                  :show-file-list="false"
                  :on-change="(file, fileList) => { handleChangeFile(file, 'testIdentificationList'); }"
                >
                  <div>
                    <div class="inner-icon"></div>
                    <div class="inner-tip" @click.stop="checkReason('dialogTestFailReason')">查看原因</div>
                    <div class="inner-desc">审核失败，请再次提交</div>
                    <div class="icon-download"></div>                           
                  </div>
                </el-upload>
              </template>
            </template>
            <el-upload
              v-else
              class="identification-inner current"
              action="no"
              accept=".png,.jpg"
              :auto-upload="false"
              :multiple="false"
              :show-file-list="false"
              :on-change="(file, fileList) => { handleChangeFile(file, 'testIdentificationList');}"
            >
              <div class="">
                <div class="inner-icon"></div>
                <div class="inner-desc">提交认证截图</div>
                <div class="icon-download"></div>
              </div>
            </el-upload>
          </template>
        </template>
        <div v-else class="identification-inner innerTip">
          <div class="inner-icon"></div>
          <div class="inner-desc">请先登录</div>
          <div class="icon-download"></div>
        </div>
      </div>
    </div> 
    <div class="tools-box">
      <div class="left-red-title">
        <div class="left-inner">
          <div class="border-left"></div>
          <div class="title-text">工具包下载</div>
        </div>
      </div>
      <div class="tools-inner-content">
        <div class="tools-inner" @click="handleDownload(1001)">
          <div class="inner-icon"></div>
          <div class="inner-desc">前端工具包下载</div>
          <div class="icon-download"></div>
        </div>
        <!-- <div class="tools-inner current" @click="handleDownload(2002)">
          <div class="inner-icon"></div>
          <div class="inner-desc">后端工具包下载</div>
          <div class="icon-download"></div>
        </div> -->
      </div>
    </div>
    <!-- <div class="test-env-box">
      <div class="left-red-title">
        <div class="left-inner">
          <div class="border-left"></div>
          <div class="title-text">测试环境</div>
          <div v-if="!userIsVip" class="title-desc">升级为专业版之后可查看</div>
        </div>
      </div>
      <div :class="['test-env-inner', userIsVip ? 'isvip' : '']">
        <div v-if="!userIsVip" class="novip-text">
          在不同的视角看不同的风景此处乃专业版的视角
        </div>
        <div v-if="userIsVip" class="vip-items-box">
          <div class="vip-item-box">
            <img class="icon-item" src="@/assets/icon_user_name.png" />
            <div class="label-item">用户名</div>
            <div class="label-item-dot">:</div>
            <div class="cont-item">
              {{ userInfo.user_remark_016 || "等待配置" }}
            </div>
          </div>
          <div class="vip-item-box">
            <img class="icon-item" src="@/assets/icon_domain_name.png" />
            <div class="label-item">域名</div>
            <div class="label-item-dot">:</div>
            <div class="cont-item">
              {{ userInfo.user_remark_015 || "等待配置" }}
            </div>
          </div>
          <div class="vip-item-box">
            <img class="icon-item" src="@/assets/icon_user_pwd.png" />
            <div class="label-item">密码</div>
            <div class="label-item-dot">:</div>
            <div
              class="cont-item"
              v-if="!showPassword && userInfo.user_remark_017"
            >
              ******
            </div>
            <div class="cont-item" v-else>
              {{ userInfo.user_remark_017 || "等待配置" }}
            </div>
            <div
              v-if="!showPassword && userInfo.user_remark_017"
              @click="handleShowPassword"
            >
              <img
                class="icon-check"
                style="width: 30px"
                src="@/assets/icon_check_password.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="height_box" style="height: 50px;"></div>
    <!--领取优惠券-->
    <!--<div class="coupon-box">
      <div class="left-red-title">
        <div class="left-inner">
          <div class="border-left"></div>
          <div class="title-text">优惠券</div>
          &lt;!&ndash; <div class="title-desc">升级为专业版之后可查看</div> &ndash;&gt;
        </div>
        <el-tooltip
          placement="bottom-end"
          popper-class="coupon-tooltip-box"
          :enterable="true"
        >
          <div slot="content" class="coupon-tooltip">
            <div class="tip-item">
              新人一折优惠券：购买12个月会员方<br />可使用新人一折优惠券，此券不可与<br />其他优惠同享；
            </div>
            <div class="tip-item">
              项目发布抵扣券：发布项目专用券，<br />即发布项目时，方可使用此券。
            </div>
          </div>
          <div class="right-inner">
            <img class="icon-remind" src="@/assets/icon_remind_red.png" />
            <span>使用说明</span>
          </div>
        </el-tooltip>
      </div>
      <div class="coupon-inner">
        <template v-for="(item, idx) in couponList">
          <div
            :key="idx"
            :class="[
              'center-coupon-item-box',
              item.status === 2 ? 'timeout' : '',
            ]"
          >
            <div class="coupon-item-top">
              <div class="top-inner">
                <div class="name-btn-box">
                  <div class="symbol-money-box" v-if="item.score_type == 220">
                    ¥
                  </div>
                  <div
                    :class="[
                      'name-cont',
                      item.score_type == 220 ? 'name-money-cont' : '',
                    ]"
                  >
                    {{ item.score_type == 220 ? item.value_4_use_rule : "" }}
                    <div v-if="item.score_type === 220" class="name-desc-cont">
                      {{ item.score_remark }}
                    </div>
                    <div v-else class="name-desc-cont">新人1折优惠券</div>
                  </div>
                  <el-button
                    v-if="item.coupon_status === 101"
                    class="custom-button btn-getcoupon btn-getnow"
                    @click.stop="handleGetCouponNow(item)"
                    >立即领取
                  </el-button>
                  <el-button
                    v-if="item.coupon_status === 102"
                    class="custom-button btn-notuse"
                    >待使用</el-button
                  >
                  <el-button
                    v-if="item.coupon_status === 103"
                    class="custom-button btn-used"
                    >已使用</el-button
                  >
                </div>
              </div>
            </div>
            <div class="split-radius-line-box">
              <div class="left-box"></div>
              <div class="split-line"></div>
              <div class="right-box"></div>
            </div>
            <div class="coupon-item-bottom">
              <div
                :class="[
                  'coupon-rules-box',
                  item.isExpand ? 'expand-rule' : '',
                ]"
              >
                <div
                  v-for="(itemRule, idxRule) in item.rules"
                  :key="idxRule"
                  class="coupon-rule-item"
                >
                  {{ itemRule }}
                </div>
              </div>
              <div
                :class="['icon-expand', item.isExpand ? 'expand' : '']"
                @click="handleExpandDetail(item)"
              ></div>
            </div>
            &lt;!&ndash; <div class="mask"></div> &ndash;&gt;
          </div>
        </template>
      </div>
    </div>-->
    <CompCouponQrcode ref="compCouponQrcode"></CompCouponQrcode>
    <CompRecharge ref="compRecharge"></CompRecharge>
    <DevFailReason ref="dialogDevFailReason" :identificationList="devIdentificationList"></DevFailReason>
    <TestFailReason ref="dialogTestFailReason" :identificationList="testIdentificationList"></TestFailReason>
    <BackFailReason ref="dialogBackFailReason" :identificationList="backIdentificationList"></BackFailReason>
  </div>
</template>
<script>
import { Base64 } from "js-base64";
import CompCouponQrcode from "@/components/dialog/GetCouponQrcode";
import CompRecharge from "@/components/dialog/Recharge";
import DevFailReason from "@/components/dialog/DevFailReason";
import TestFailReason from "@/components/dialog/TestFailReason";
import BackFailReason from "@/components/dialog/BackFailReason";
import pageCommon from "@/utils/pagecommon";
import goodsApi from "@/api/goods";
import couponApi from "@/api/coupon";
import middleApi from '@/api/middleData';
import identificationApi from '@/api/identification'
export default {
  name: "AccountCenter",
  components: { CompCouponQrcode, CompRecharge, DevFailReason, TestFailReason, BackFailReason },
  created() {
  },
  mounted() {
    let _this = this;
    _this.$store.dispatch("acCenterNavIndex", 0);
    _this.getGoodsInfo();
  },
  data() {
    return {
      price: 0,
      couponList: [],
      couponData: [],
      agentInfo: {},
      devIdentificationList: {},
      devIdentificationNum: 0,
      testIdentificationList: {},
      testIdentificationNum: 0,
      backIdentificationList: {},
      backIdentificationNum: 0,
      showPassword: false,
      codeurl:'',
      testCodeurl:'',
      backCodeurl:'',
      fit:'cover'
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
    userIsVip: function () {
      let _this = this;
      if (
        _this.userInfo &&
        _this.userInfo.user_remark_012 &&
        _this.userInfo.user_remark_012 === "1202"
      ) {
        return true;
      }
      return false;
    },
    isVip: function () {
      let _this = this;
      return true;
    },
  },
  methods: {
    getDays: function (val) {
      let startDate = new Date(val.replace(/-/g, "/"));
      let endDate = startDate.setDate(startDate.getDate() + 7);
      let currentDate = new Date().getTime();
      let time = (endDate-currentDate)/1000;
      let minute = 0;// 分
      let hour = 0;// 小时
      let day = 0;// 天
      if (time > 60) {
          minute = parseInt(time / 60);
          time = parseInt(time % 60);
          if (minute > 60) {
              hour = parseInt(minute / 60);
              minute = parseInt(minute % 60);
              if (hour > 24) {
                  day = parseInt(hour / 24);
                  hour = parseInt(hour % 24);
              }
          }
      }
      let daysAfter = '';
      if (minute > 0) {
          daysAfter = "" + parseInt(minute) + "分" + daysAfter;
      }
      if (hour > 0) {
          daysAfter = "" + parseInt(hour) + "小时" + daysAfter;
      }
      if (day > 0) {
          daysAfter = "" + parseInt(day) + "天" + daysAfter;
      }
      return daysAfter;
    },
    handleShowPassword: function () {
      let _this = this;
      _this.showPassword = !_this.showPassword;
    },
    getGoodsInfo: function () {
      let _this = this;
      let requestData = {
        isloading: true,
      };
      pageCommon.apiRequestCommon(goodsApi, "showGoodsInfo", requestData).then(
        (res) => {
          _this.agentInfo = res.public_agent_info;
          this.codeurl=_this.agentInfo.agent_remark_008;
          this.testCodeurl=_this.agentInfo.agent_remark_012;
          this.backCodeurl=_this.agentInfo.agent_remark_014;
          if (
            res &&
            res.public_goods_list &&
            res.public_goods_list.length > 0
          ) {
            let goodsInfo = res.public_goods_list[0];
            //3个月打9折，6个月打8折，12个月5折
            let price =
              goodsInfo.publicGoodsSupply4Shop.new_price_4_shop_retail;
            _this.price = price;
            // _this.getCouponData();
            // _this.getAccountAndCoupon();
            _this.getIdentificationList();
            _this.getTestIdentificationList();
            _this.getBackIdentificationList();
          } else {
          }
        },
        (err) => {
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
          }
        }
      );
    },
    getIdentificationList: function () {
      let requestData = {
        isloading: true,
        type_inner_app:5005,
        is_online: 0,
        id_public_user_info: this.userInfo.id_public_user_info
      };
      pageCommon.apiRequestCommon(identificationApi, "getIdentificationData", requestData).then((res) => {
          this.devIdentificationList = res.page_content[0];
          this.devIdentificationNum = res.result_num;
        }
      );
    },
    getTestIdentificationList: function () {
      let requestData = {
        isloading: true,
        type_inner_app:6006,
        is_online: 0,
        id_public_user_info: this.userInfo.id_public_user_info
      };
      pageCommon.apiRequestCommon(identificationApi, "getIdentificationData", requestData).then((res) => {
          this.testIdentificationList = res.page_content[0];
          this.testIdentificationNum = res.result_num;
          console.log(this.testIdentificationList)
        }
      );
    },
    getBackIdentificationList: function () {
      let requestData = {
        isloading: true,
        type_inner_app:7007,
        is_online: 0,
        id_public_user_info: this.userInfo.id_public_user_info
      };
      pageCommon.apiRequestCommon(identificationApi, "getIdentificationData", requestData).then((res) => {
          this.backIdentificationList = res.page_content[0];
          this.backIdentificationNum = res.result_num;
          console.log(this.backIdentificationList)
        }
      );
    },
    getCouponData: function () {
      let requestData = {
        is_online: 0,
        isloading: true,
      };
      pageCommon
        .apiRequestCommon(couponApi, "getCoupons", requestData)
        .then((response) => {
          if (response.public_score_list.length) {
            this.couponData = response.public_score_list;
          }
        });
    },
    getAccountAndCoupon: function () {
      let _this = this;
      let requestData = {
        begin_idx: 0,
        limit: 1000,
        id_public_user_info: _this.userInfo.id_public_user_info,
        isloading: true,
      };
      pageCommon
        .apiRequestCommon(couponApi, "getUserGetCoupons", requestData)
        .then(
          (res) => {
            let userCouponList =
              res && res.public_score_list ? res.public_score_list : [];
            let couponList = [];
            for (let i = 0; i < userCouponList.length; i++) {
              const element = userCouponList[i];
              let coupon_status = 0; //待领取
              if (element.is_online == 0) {
                coupon_status = 102; //未使用
              } else {
                coupon_status = 103; //已使用
              }
              if (element.score_type == 104) {
                element.coupon_status = coupon_status;
                element.isExpand = false;
                this.couponData.forEach((item) => {
                  if (item.id_public_rule_4_score == element.append_inner_key) {
                    if (item.rule_4_score_remark_004) {
                      element.rules = item.rule_4_score_remark_004.split("\n");
                    } else {
                      element.rules = [];
                    }
                  }
                });
                element.isDiscount = true;
                element.discount = element.rule_4_score_remark_005;
                couponList.push(element);
              }
              if (element.score_type == 220) {
                element.coupon_status = coupon_status;
                element.isExpand = false;
                this.couponData.forEach((item) => {
                  if (item.id_public_rule_4_score == element.append_inner_key) {
                    if (item.rule_4_score_remark_004) {
                      element.rules = item.rule_4_score_remark_004.split("\n");
                    } else {
                      element.rules = [];
                    }
                  }
                });

                element.isDiscount = false;
                element.discount = 1;
                couponList.push(element);
              }
            }
            if (couponList.length) {
              _this.couponList = couponList;
            } else {
              setTimeout(() => {
                _this.getWaitCouponList();
              }, 1000);
            }
          },
          (err) => {
            _this.isRequesting = false;
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
            _this.showDialog = false;
          }
        );
    },
    getWaitCouponList: function () {
      let _this = this;
      let requestData = {
        isloading: false,
      };
      pageCommon
        .apiRequestCommon(couponApi, "getWaitCoupons", requestData)
        .then(
          (res) => {
            let userCouponList = [];
            let userCouponData =
              res && res.public_score_list ? res.public_score_list : [];
            userCouponData.forEach((element) => {
              if (
                element.type_rule_4_score === 104 ||
                element.type_rule_4_score === 220
              ) {
                userCouponList.push(element);
              }
            });
            userCouponList.forEach((element) => {
              let coupon_status = 104; //不能领取
              if (element.is_online == 0) {
                coupon_status = 101; //待领取
              }
              if (element.type_rule_4_score == 104) {
                element.coupon_status = coupon_status;
                element.score_type = element.type_rule_4_score;
                element.score_remark = element.score_rule_remark;
                element.isExpand = false;
                if (element.rule_4_score_remark_004) {
                  element.rules = element.rule_4_score_remark_004.split("\n");
                } else {
                  element.rules = [];
                }
                element.isDiscount = true;
                element.discount = element.rule_4_score_remark_005;
              }
              if (element.type_rule_4_score == 220) {
                element.coupon_status = coupon_status;
                element.score_type = element.type_rule_4_score;
                element.score_remark = element.score_rule_remark;
                element.isExpand = false;
                if (element.rule_4_score_remark_004) {
                  element.rules = element.rule_4_score_remark_004.split("\n");
                } else {
                  element.rules = [];
                }
                element.isDiscount = false;
                element.discount = 1;
                //value_4_use_rule
              }
            });
            _this.couponList = userCouponList;
          },
          (err) => {
            _this.isRequesting = false;
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
            _this.showDialog = false;
          }
        );
    },
    handleExpandDetail: function (item) {
      item.isExpand = !item.isExpand;
    },
    handleUpdateNow: function () {
      let _this = this;
      _this.$refs.compRecharge.handleShow();s
    },
    handleGetCouponNow: function (item) {
      let _this = this;
      item.status = 1;
      _this.$refs.compCouponQrcode.showDialog = true;
    },
    handleDownloadTest(key){
      var url_obj={
        1001:'https://global-application-001.downline.cn/www.duzikai.com/goods_image/duzikai_written_examination_certification_20230213.zip',
        1002:'https://global-application-001.downline.cn/www.duzikai.com/goods_image/5RBnQe1681861021498n.md',
        1003:'https://global-application-001.downline.cn/www.duzikai.com/goods_image/duzikai_back_authentication_20230505.zip'
      };
      var url = url_obj[key];
      if(url){
        window.open(url);
      }else{
        this.$message.error("暂无可下载的测试认证题, 请联系相关人员");
      }
    },
    checkReason(key){
      this.$refs[key].showDialog = true;
    },
    checkPic(url){
      console.log(url)
      window.open(url);
    },
    handleChangeFile: function (file,key) {
      console.log(key)
      var key_obj={
        'devIdentificationList':5005,
        'testIdentificationList':6006,
        'backIdentificationList':7007
      }
      let _this = this;
      if (file.status !== "ready") {
        return;
      }
      this.$confirm('只有一次审核机会，不支持申诉和交流沟通；审核标准以考虑细节和代码习惯风格为主，是否继续提交', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = this.$cookies.get("ossParams");
        if (!data) {
          this.$message.error("上传失败，缺少ossParams");
          return;
        }
        if (file.size / 1024 / 1024 > 50) {
          this.$message.error("上传文件大小不能超过 50MB!");
          return;
        }
        const loading = _this.$loading({});
        data = JSON.parse(Base64.decode(data));
        this.$uploadNormal(data, file, false).then(
          (res) => {
            let requestData = {
              isloading: false,
              type_inner_app:key_obj[key],
              id_public_user_info: this.userInfo.id_public_user_info,
              mid_table_remark_001: this.userInfo.nick_name,
              mid_table_remark_002: this.userInfo.weichat_img,
              mid_table_remark_003: this.userInfo.user_phone,
              mid_table_remark_004: res,
              mid_table_remark_005: 5001,
            }
            let requestExistData = {
              isloading:false,
              is_online:0,
              type_inner_app:key_obj[key],
              id_public_user_info:this.userInfo.id_public_user_info,
              mid_table_remark_005:5001
            };
            pageCommon.apiRequestCommon(identificationApi, 'getIdentificationData', requestExistData)
              .then((res) => {
                  if(res.result_num==0){
                    pageCommon.apiRequestCommon(identificationApi, 'insertIdentificationData', requestData).then(
                      (res) => {
                        this[key] = res.page_content[0];
                        loading.close();
                      },
                      (err) => {
                        _this.$message.error(err);
                        loading.close();
                      }
                    )
                  }else{
                    this.$message.error("已存在正在审核的认证记录，请耐心等待");
                    loading.close();
                  }
                }
              );
            },
          (err) => {
            _this.$message.error(err);
            loading.close();
          }
        );
      }).catch(() => {
        loading.close();
      });
    },
    handleChangePay: function (file,key) {
      var key_obj={
        'devIdentificationList':5005,
        'testIdentificationList':6006,
        'backIdentificationList':7007
      }
      let _this = this;
      if (file.status !== "ready") {
        return;
      }
      let data = this.$cookies.get("ossParams");
      if (!data) {
        this.$message.error("上传失败，缺少ossParams");
        return;
      }
      if (file.size / 1024 / 1024 > 50) {
        this.$message.error("收款码不能超过 50MB!");
        return;
      }
      if(!this[key].id_public_middle_table){
        this.$message.error("上传遇到问题，请刷新页面");
        return;
      }
      const loading = _this.$loading({});
      data = JSON.parse(Base64.decode(data));
      this.$uploadNormal(data, file, false).then(
        (res) => {
          var imageLink = res;
          let requestData = {
            isloading: false,
            type_inner_app:key_obj[key],
            id_public_middle_table:this[key].id_public_middle_table,
            mid_table_remark_014:imageLink,
            mid_table_remark_016:1601
          }
          pageCommon
            .apiRequestCommon(identificationApi, "insertIdentificationData", requestData).then(
            (res) => {
              this.$set(this[key],'mid_table_remark_014',imageLink)
              this.$set(this[key],'mid_table_remark_016',1601)
              this.$message.success("收款码上传成功");
              loading.close();
            },
            (err) => {
              _this.$message.error(err);
              loading.close();
            }
          )
        },
        (err) => {
          _this.$message.error(err);
          loading.close();
        }
      );
    },
    handleDownload(type) {
      if (type === 1001) {
        if (this.agentInfo.agent_remark_007) {
          this.insertMiddleData(type, this.agentInfo.agent_remark_007)
        } else {
          this.$confirm("暂无可下载的工具包, 请联系相关人员", "提示", {
            type: "warning",
            showCancelButton: false,
          }).then(() => {});
        }
      } else {
        if (this.agentInfo.agent_remark_006) {
          this.insertMiddleData(type, this.agentInfo.agent_remark_006)
        } else {
          this.$confirm("暂无可下载的工具包, 请联系相关人员", "提示", {
            type: "warning",
            showCancelButton: false,
          }).then(() => {});
        }
      }
    },
    insertMiddleData(type, link) {
      let params = {
        isloading: false,
        id_public_user_info: this.userInfo.id_public_user_info,
        mid_table_remark_004: type === 1001 ? '401' : '402'
      }
      pageCommon.apiRequestCommon(middleApi, "getInsertData", params).then(
        (res) => {
          if (res.page_content.length) {
            let requestData = {
              isloading: false,
              id_public_user_info: this.userInfo.id_public_user_info,
              id_public_middle_table: res.page_content[0].id_public_middle_table,
              mid_table_remark_001: this.userInfo.nick_name,
              mid_table_remark_002: type === 1001 ? '前端工具包' : '后端工具包',
              mid_table_remark_004: type === 1001 ? '401' : '402',
              mid_table_remark_003: Number(res.page_content[0].mid_table_remark_003) + 1
            }
            pageCommon.apiRequestCommon(middleApi, "insertData", requestData).then(
              (res) => {
                window.open(link);
              },
              (err) => {
              }
            )
          } else {
            let requestData = {
              isloading: false,
              id_public_user_info: this.userInfo.id_public_user_info,
              mid_table_remark_001: this.userInfo.nick_name,
              mid_table_remark_002: type === 1001 ? '前端工具包' : '后端工具包',
              mid_table_remark_004: type === 1001 ? '401' : '402',
              mid_table_remark_003: 1
            }
            pageCommon.apiRequestCommon(middleApi, "insertData", requestData).then(
              (res) => {
                window.open(link);
              },
              (err) => {
              }
            )
          }
        },
        (err) => {
        }
      )
    }
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
@import "../../assets/css/center.less";
.accountcenter {
  position: relative;
  width: 100%;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  /deep/.left-red-title {
    padding-bottom: 12px;
    border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
  }
  .renewal-recharge-box {
    position: relative;
    width: 100%;
    margin-top: 50px;
    /deep/.left-red-title {
      padding-bottom: 12px;
      border-bottom: 1px solid #eeeeee;
      box-sizing: border-box;
    }
    .renewal-recharge-inner {
      position: relative;
      width: 378px;
      height: 335px;
      background: #ffffff;
      border: 1px solid #eeeeee;
      border-radius: 4px;
      box-sizing: border-box;
      margin-top: 32px;
      background: url(~@/assets/icon_vip_white.png) no-repeat right top;
      background-size: 169px 145px;
      .name-price-box {
        position: relative;
        width: 342px;
        height: 221px;
        border-bottom: 1px solid #eeeeee;
        padding-top: 60px;
        padding-left: 32px;
        box-sizing: border-box;
        text-align: center;
        margin: 0 auto;
        font-family: Source Han Sans CN;
        font-weight: bold;
        .name-box {
          position: relative;
          width: 100%;
          font-size: 32px;
          color: #222222;
          line-height: 32px;
          text-align: left;
        }
        .price-box {
          position: relative;
          width: 100%;
          font-size: 18px;
          color: #222222;
          line-height: 18px;
          text-align: left;
          margin-top: 40px;
          .price-cont {
            position: relative;
            padding-right: 10px;
            font-size: 36px;
            color: #ec4040;
            line-height: 36px;
          }
        }
      }
      .btn-updatenow {
        position: relative;
        width: 224px;
        height: 46px;
        line-height: 46px;
        font-size: 18px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        margin-top: 33px;
      }
    }
  }
  .identification-box,
  .test-env-box,
  .tools-box,
  .coupon-box {
    position: relative;
    width: 100%;
    margin-top: 80px;
    .identification-inner,
    .test-env-inner,
    .tools-inner {
      position: relative;
      width: 100%;
      height: 200px;
      border: 1px solid #eeeeee;
      border-radius: 4px;
      box-sizing: border-box;
      margin-top: 32px;
      display: flex;
      display: -webkit-flex;
    }
  }
  .tools-inner-content,.identification-inner-content {
    display: flex;
    align-content: center;
    justify-content: space-between;
    .tools-inner,.identification-inner {
      width: 49%;
    }
  }
  .test-env-box {
    .test-env-inner {
      background: url(~@/assets/icon_bg_testdev.png) no-repeat 807px 46px #f4f4f4;
      background-size: 107px 120px;
      &.isvip {
        background: url(~@/assets/bg_development_environment.png) no-repeat
          797px 40px #f4f4f4;
        background-size: 120px 120px;
      }
      .novip-text {
        position: relative;
        width: 295px;
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #666666;
        line-height: 40px;
        margin-top: 60px;
        margin-left: 76px;
        text-align: left;
      }
      .vip-items-box {
        position: relative;
        width: 100%;
        height: 108px;
        padding-left: 77px;
        box-sizing: border-box;
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
        justify-content: space-between;
        margin-top: 46px;
        .vip-item-box {
          position: relative;
          width: 100%;
          display: flex;
          display: -webkit-flex;
          flex-direction: row;
          align-items: center;
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #222222;
          line-height: 20px;
          .icon-item {
            position: relative;
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }
          .label-item {
            position: relative;
            width: 60px;
            text-align-last: justify;
            text-align: justify;
          }
          .label-item-dot {
            position: relative;
            margin-left: 10px;
          }
          .cont-item {
            position: relative;
            margin-left: 24px;
          }
        }
      }
    }
  }
  .identification-box {
    margin-right:50px;
    .identification-inner {
      padding: 40px 0 0 32px;
      display: block;
      background-color: #f4f4f4;
      position: relative;
      cursor: pointer;
      font-weight: bold;
      .inner-icon {
        width: 80px;
        height: 80px;
        margin-bottom: 20px;
        background: url(~@/assets/icon_down.png) no-repeat right top;
      }
      .inner-desc {
        color: #666666;
        text-align: left;
      }
      .icon-download {
        position: absolute;
        bottom: 42px;
        right: 26px;
        width: 46px;
        height: 46px;
        background: url(~@/assets/icon_download.png) no-repeat right top;
      }
      &:hover {
        border-color: #ec4040;
        background-color: #fff8f8;
        .inner-icon {
          background: url(~@/assets/icon_down_hover.png) no-repeat right
            top;
        }
        .inner-desc {
          color: #ec4040;
        }
        .icon-download {
          background: url(~@/assets/icon_download_current.png) no-repeat right
            top;
        }
      }
    }
    .identification-inner.innerTip {
      padding: 40px 0 0 32px;
      display: block;
      background-color: #f4f4f4;
      position: relative;
      cursor: pointer;
      font-weight: bold;
      .el-upload{
        width:100%;
        border:none;
      }
      .inner-icon {
        width: 80px;
        height: 80px;
        margin-bottom: 20px;
        background: url(~@/assets/icon_submit.png) no-repeat right top;
      }
      .inner-desc {
        color: #666666;
        text-align: left;
      }
      .icon-download {
        position: absolute;
        bottom: 42px;
        right: 26px;
        width: 46px;
        height: 46px;
        transform:rotatex(180deg);
        background: url(~@/assets/icon_download.png) no-repeat right top;
      }
      &:hover {
        border: 1px solid #eeeeee;
      }
    }
    .identification-inner.current {
      padding: 40px 0 0 32px;
      display: block;
      background-color: #f4f4f4;
      position: relative;
      cursor: pointer;
      font-weight: bold;
      .el-upload{
        width:100%;
        border:none;
      }
      .inner-icon {
        width: 80px;
        height: 80px;
        margin-bottom: 20px;
        background: url(~@/assets/icon_submit.png) no-repeat right top;
      }
      .inner-desc {
        color: #666666;
        text-align: left;
      }
      .icon-download {
        position: absolute;
        bottom: 42px;
        right: 26px;
        width: 46px;
        height: 46px;
        transform:rotatex(180deg);
        background: url(~@/assets/icon_download.png) no-repeat right top;
      }
      &:hover {
        background-color: #fff8f8;
        border-color: #ec4040;
        .inner-icon {
          background: url(~@/assets/icon_submit_hover.png) no-repeat right top;
        }
        .inner-desc {
          color: #ec4040;
        }
        .icon-download {
          transform:rotatex(180deg);
          background: url(~@/assets/icon_download_current.png) no-repeat right top;
        }
      }
    }
    .identification-inner.fail {
      padding: 40px 0 0 32px;
      display: block;
      background-color: #fff8f8;
      border-color: #ec4040;
      position: relative;
      cursor: default;
      font-weight: bold;
      .el-upload{
        width:100%;
        border:none;
      }
      .inner-icon {
        width: 80px;
        height: 80px;
        margin-bottom: 20px;
        background: url(~@/assets/icon_fail_hover.png) no-repeat right top;
      }
      .inner-desc {
        color: #ec4040;
        text-align: left;
      }
      .inner-tip {
        position: absolute;
        top: 46px;
        right: 32px;
        font-size: 16px;
        font-weight: bolder;
        color: #0072FF;
      }
      .icon-download {
        position: absolute;
        bottom: 42px;
        right: 26px;
        width: 46px;
        height: 46px;
        transform:rotatex(180deg);
        background: url(~@/assets/icon_download_current.png) no-repeat right top;
      }
      &:hover {
        background-color: #fff8f8;
        border-color: #ec4040;
        .inner-icon {
          background: url(~@/assets/icon_fail_hover.png) no-repeat right top;
        }
        .inner-desc {
          color: #ec4040;
        }
        .icon-download {
          transform:rotatex(180deg);
          background: url(~@/assets/icon_download_current.png) no-repeat right top;
        }
      }
    }
    .identification-inner.succeed {
      padding: 40px 0 0 32px;
      display: block;
      background-color: #EDFFF4;
      border-color: #5DBA82;
      position: relative;
      cursor: default;
      font-weight: bold;
      .el-upload{
        width:100%;
        border:none;
      }
      .inner-icon {
        width: 80px;
        height: 80px;
        margin-bottom: 20px;
        background: url(~@/assets/icon_succeed.png) no-repeat right top;
      }
      .inner-desc {
        color: #5DBA82;
        text-align: left;
        display:flex;
        flex-direction: row;
        align-items: center;
        .icon-remind-tip{
          margin-left:6px;
          width: 16px;
          height: 16px;
          background-size:100%;
          background-position:center;
          background-repeat:no-repeat;
          background-image:url(~@/assets/icon_remind_tip.png);
        }
      }
      .inner-pay-tip {
        position: absolute;
        top: 46px;
        right: 32px;
        font-size: 16px;
        font-weight: bolder;
        color: #ec4040;
        &.green{
          font-size: 16px;
          font-weight: bolder;
          color: #5DBA82;
        }
      }
      .icon-download {
        position: absolute;
        bottom: 43px;
        right: 26px;
        width: 46px;
        height: 46px;
        background-size:100%;
        background-position:center;
        background-repeat:no-repeat;
        background-image:url(~@/assets/qr_unselected.png);
        &:hover {
          background-image:url(~@/assets/qr_selected.png);
        }
      }
      .upload-code{
        height:0;
      }
    }
    .identification-inner.under_review {
      padding: 40px 0 0 32px;
      display: block;
      background-color: #F4F4F4;
      border-color: #EEEEEE;
      position: relative;
      cursor: default;
      font-weight: bold;
      .el-upload{
        width:100%;
        border:none;
      }
      .inner-icon {
        width: 80px;
        height: 80px;
        margin-bottom: 20px;
        background: url(~@/assets/icon_undereview.png) no-repeat right top;
      }
      .inner-desc {
        color: #666666;
        text-align: left;
      }
      .icon-download {
        position: absolute;
        bottom: 42px;
        right: 26px;
        width: 46px;
        height: 46px;
        transform:rotatex(180deg);
        background: url(~@/assets/icon_download.png) no-repeat right top;
      }
    }
    
  }
  .tools-box {
    .tools-inner {
      padding: 40px 0 0 32px;
      display: block;
      background-color: #f4f4f4;
      position: relative;
      cursor: pointer;
      font-weight: bold;
      .inner-icon {
        width: 80px;
        height: 80px;
        margin-bottom: 20px;
        background: url(~@/assets/icon_front_end.png) no-repeat right top;
      }
      .inner-desc {
        color: #666666;
        text-align: left;
      }
      .icon-download {
        position: absolute;
        bottom: 42px;
        right: 26px;
        width: 46px;
        height: 46px;
        background: url(~@/assets/icon_download.png) no-repeat right top;
      }
      &:hover {
        border-color: #ec4040;
        background-color: #fff8f8;
        .inner-icon {
          background: url(~@/assets/icon_front_end_current.png) no-repeat right top;
        }
        .inner-desc {
          color: #ec4040;
        }
        .icon-download {
          background: url(~@/assets/icon_download_current.png) no-repeat right top;
        }
      }
    }
    .tools-inner.current {
      padding: 40px 0 0 32px;
      display: block;
      background-color: #f4f4f4;
      position: relative;
      cursor: pointer;
      font-weight: bold;
      .inner-icon {
        width: 80px;
        height: 80px;
        margin-bottom: 20px;
        background: url(~@/assets/icon_back_end.png) no-repeat right top;
      }
      .inner-desc {
        color: #666666;
        text-align: left;
      }
      .icon-download {
        position: absolute;
        bottom: 42px;
        right: 26px;
        width: 46px;
        height: 46px;
        background: url(~@/assets/icon_download.png) no-repeat right top;
      }
      &:hover {
        background-color: #fff8f8;
        border-color: #ec4040;
        .inner-icon {
          background: url(~@/assets/icon_back_end_current.png) no-repeat right top;
        }
        .inner-desc {
          color: #ec4040;
        }
        .icon-download {
          background: url(~@/assets/icon_download_current.png) no-repeat right top;
        }
      }
    }
  }
  .coupon-box {
    .right-inner {
      position: relative;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ec4040;
      line-height: 16px;
      .icon-remind {
        position: relative;
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
    }
    .coupon-inner {
      position: relative;
      margin-top: 32px;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      flex-wrap: wrap;
      .center-coupon-item-box {
        margin-bottom: 40px;
        .mask {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          display: none;
        }
        &:nth-child(2n) {
          margin-left: 26px;
        }
        .coupon-item-top {
          .top-inner {
            position: relative;
            height: 122px;
            .name-btn-box {
              position: relative;
              width: 100%;
              padding-left: 31px;
              display: flex;
              display: -webkit-flex;
              flex-direction: row;
              align-items: self-start;
              box-sizing: border-box;
              margin-top: 47px;
              .symbol-money-box {
                position: relative;
                font-size: 28px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #221b1b;
                margin-right: 10px;
                margin-top: 12px;
              }
              .name-cont {
                position: relative;
                flex: 1;
                text-align: left;
                font-size: 32px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #221b1b;
                line-height: 48px;
                &.name-money-cont {
                  font-size: 48px;
                }
                .name-desc-cont {
                  position: relative;
                  width: 100%;
                  font-size: 27px;
                  line-height: 32px;
                  text-align: left;
                  box-sizing: border-box;
                  margin-top: 10px;
                }
              }
              .btn-getnow {
                position: relative;
                width: 139px;
                height: 48px;
                line-height: 48px;
                border-radius: 4px;
                box-sizing: border-box;
                text-align: center;
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                margin-right: 31px;
              }
              .btn-notuse {
                position: relative;
                width: 90px;
                height: 48px;
                line-height: 48px;
                background: #222222;
                border-radius: 24px 0px 0px 24px;
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #ffffff;
                text-align: center;
                box-sizing: border-box;
                cursor: auto;
              }
              .btn-used {
                position: relative;
                width: 90px;
                height: 48px;
                line-height: 48px;
                background: #c3c3c3;
                border-radius: 24px 0px 0px 24px;
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #ffffff;
                text-align: center;
                box-sizing: border-box;
                cursor: auto;
              }
            }
          }
        }
        &.timeout {
          .coupon-item-top {
            background: #f4f4f4;
            .top-inner {
              .name-btn-box {
                .symbol-money-box {
                  color: #d3d3d3;
                }
                .name-cont {
                  color: #d3d3d3;
                }
              }
            }
          }
          .split-radius-line-box {
            background: #f4f4f4;
          }
          .coupon-item-bottom {
            background: #f4f4f4;
            .coupon-rules-box {
              .coupon-rule-item {
                color: #d3d3d3;
              }
            }
            .icon-expand {
              opacity: 0.3;
            }
          }
          .mask {
            display: block;
          }
        }
      }
    }
  }

  .width100per {
    width: 100%;
  }
  .basics-form,
  .myaccount-peopleform,
  .myaccount-supplierform {
    position: relative;
    margin-top: 40px;
    .form-item {
      width: 990px;
      display: flex;
      align-items: center;
      &.form-item-base {
        margin-bottom: 30px;
        .form-item-usertype {
          margin-left: 45px;
        }
      }
      &.form-item-normal {
        padding-top: 30px;
        padding-bottom: 8px;
        box-sizing: border-box;
        border-top: 1px solid rgb(238, 238, 238);
        .buttons {
          display: flex;
          align-items: center;
          .custom-button {
            margin-left: 10px;
            &:first-child {
              margin-left: 30px;
            }
          }
        }
      }
      /deep/.el-form-item__label {
        font-size: 16px;
        font-family: "SourceHanSansCN";
        color: rgba(153, 153, 153, 1);
      }
      .txt-normalstyle {
        height: 46px;
        line-height: 46px;
        font-size: 16px;
        font-family: "SourceHanSansCN";
        color: rgba(102, 102, 102, 1);
      }
      .width690 {
        width: 690px;
      }
      .width270 {
        width: 270px;
      }
      .btn-modify {
        width: 80px;
        height: 46px;
        line-height: 46px;
        font-size: 16px;
        margin-bottom: 22px;
      }
    }
    .line {
      width: 100%;
      height: 1px;
      border-bottom: 1px solid rgb(238, 238, 238);
      margin: 30px 0;
      box-sizing: border-box;
    }
  }
}
.coupon-tooltip-box {
  &.el-tooltip__popper {
    padding: 18px;
    .coupon-tooltip {
      position: relative;
      font-size: 14px;
      font-family: Source Han Sans CN;
      color: #ffffff;
      line-height: 24px;
      .tip-item {
        position: relative;
        margin-top: 20px;
        &:first-child {
          margin-top: 0;
        }
      }
    }
  }
}
</style>
<style lang="less">
.identification-inner.current{
  .el-upload{
    width:100%;
    border:none;
  }
}
.identification-inner.fail{
  .el-upload{
    width:100%;
    border:none;
  }
}
.identification-tooltip-inner{
  max-width:350px;
  font-size:16px;
}
.el-tooltip__popper.code-custom-tooltip{
  border:none;
  box-shadow: 0px 3px 38px 0px rgba(58,58,58,0.1);
  border-radius: 4px;
  .popper__arrow{
    border:none;
  }
}
.code-tooltip-inner{
  padding:16px 18px 18px 18px;
  width:204px;
  height:230px;
  background:#FFF;
  .code-tooltip-inner-title{
    margin-bottom:12px;
    font-size: 16px;
    font-weight: bolder;
    color: #222;
    text-align:center;
  }
  .code-tooltip-inner-img-wrap{
    width:168px;
    height:168px;
    padding:14px;
    background-size:100%;
    background-position:center;
    background-repeat:no-repeat;
    background-image:url(~@/assets/bg-qrcode.png);
    .code-tooltip-inner-img{
      width:100%;
      height:100%;
    }
  }
}
</style>
